import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ngHelper } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-cake-build-question',
  templateUrl: './ui-cake-build-question.component.html'
})
export class UiCakeBuildQuestionComponent implements OnChanges {
  @Input() public helpText: string = '';

  @Input() public answer: string = '';

  @Input() public maxLength: number = 0;
  @Input() public question: string;

  @Input() public price: number;
  @Input() public currency = 'kr';

  @Output() public onChange: EventEmitter<any> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'maxLength', (maxLength: any) => {
      if (this.answer && this.answer.length > maxLength) {
        const answer = this.answer.substr(0, maxLength);
        setTimeout(() => {
          this.onChange.emit(answer);
        });
      }
    });
  }
}

